import { render, staticRenderFns } from "./tabCrmCustomerContact.vue?vue&type=template&id=ba25c7f2&scoped=true&"
import script from "./tabCrmCustomerContact.vue?vue&type=script&lang=js&"
export * from "./tabCrmCustomerContact.vue?vue&type=script&lang=js&"
import style0 from "./tabCrmCustomerContact.vue?vue&type=style&index=0&id=ba25c7f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba25c7f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba25c7f2')) {
      api.createRecord('ba25c7f2', component.options)
    } else {
      api.reload('ba25c7f2', component.options)
    }
    module.hot.accept("./tabCrmCustomerContact.vue?vue&type=template&id=ba25c7f2&scoped=true&", function () {
      api.rerender('ba25c7f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Sales/components/crm/tabs/tabCrmCustomerContact.vue"
export default component.exports